import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiCheck, FiChevronUp } from "react-icons/fi";
import Header from "../component/header/2SN";
import Footer from "../component/footer/2SN_Footer";




class Laravel extends Component {
    constructor() {
        super()
        this.state = {
            isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal() {
        this.setState({ isOpen: true })
    }
    render() {
        return (
            <React.Fragment>

                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Laravel || 2SN Healthcare ltd' pageUrl='/laravel' metaTitle="Laravel" metaImage="/assets/images/bg/bg-image-25.jpg"
                    metaDescription="Leverage the power of Laravel, one of the most popular backend web application frameworks, with expressive and elegant syntax. 2SN Healthcare ltd' team of experts provides top-notch development services." />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--25" data-black-overlay="5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">Laravel</h2>
                                    <p>Laravel is one of the most popular backend web application frameworks with expressive, elegant syntax.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}


                {/* Start Page Wrapper  */}
                <main className="page-wrapper">

                    {/* Start Columns Area  */}
                    <div className="rn-columns-area ptb--120 bg_color--5">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="single-column">
                                        {/* <h4 className="tilte">One Full</h4> */}
                                        <p> A web application platform built around various functions like security such as authentication and authorization, customer communication, accessibility and affordability to use irrespective of the size of your application.</p>
                                        <p>Laravel is one of the most popular backend web application frameworks with expressive, elegant syntax. We believe development must be an enjoyable, creative experience to be truly fulfilling. Laravel attempts to take the pain out of development by easing common tasks used in the majority of web projects, such as authentication, routing, sessions, and caching.</p>
                                        <p>Laravel aims to make the development process a pleasing one for the developer without sacrificing application functionality. Happy developers make the best code. To this end, we've attempted to combine the very best of what we have seen in other web frameworks, including frameworks implemented in other languages, such as Ruby on Rails, ASP.NET MVC, and Sinatra.</p>
                                        <p>Laravel is accessible, yet powerful, providing powerful tools needed for large, robust applications. A superb inversion of control container, expressive migration system, and tightly integrated unit testing support give you the tools you need to build any application with which you are tasked.</p>
                                        <h4 className="title">OUR SERVICES</h4>
                                        <p>2SN Healthcare ltd provides a wide array of solutions including Laravel development, Laravel customization, Laravel integration with third party integration, Shopping carts with Laravel CMS, Laravel upgrade, maintenance and support service.</p>
                                        <h4 className="title">Our Laravel solutions provide the following:</h4>

                                        <ul className="list-style--1">
                                            <li><FiCheck />Laravel custom Landing Page Design.</li>
                                            <li><FiCheck />Laravel plugins creation and installation.</li>
                                            <li><FiCheck />Shipping and Payment modules development.</li>
                                            <li><FiCheck />Laravel upgrade service.</li>
                                            <li><FiCheck />Our Laravel consultants can assist you narrow your ecommerce choices.</li>
                                            <li><FiCheck />Laravel integration with another party application.</li>
                                            <li><FiCheck />Conversion from any present platform to Laravel e-commerce.</li>
                                            <li><FiCheck />Creating shopping carts using Laravel.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Start Columns Area  */}






                </main>
                {/* End Page Wrapper  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />

            </React.Fragment>
        )
    }
}
export default Laravel;